var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecifyExp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10.5H7.5C7.9125 10.5 8.25 10.1625 8.25 9.75V1.5C8.25 1.0875 7.9125 0.75 7.5 0.75H5.25C4.8375 0.75 4.5 1.0875 4.5 1.5V9.75C4.5 10.1625 4.8375 10.5 5.25 10.5ZM0.75 10.5H3C3.4125 10.5 3.75 10.1625 3.75 9.75V1.5C3.75 1.0875 3.4125 0.75 3 0.75H0.75C0.3375 0.75 0 1.0875 0 1.5V9.75C0 10.1625 0.3375 10.5 0.75 10.5ZM9 1.5V9.75C9 10.1625 9.3375 10.5 9.75 10.5H12C12.4125 10.5 12.75 10.1625 12.75 9.75V1.5C12.75 1.0875 12.4125 0.75 12 0.75H9.75C9.3375 0.75 9 1.0875 9 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecifyExp);
export default __webpack_public_path__ + "static/media/specify-exp.6e996cf3.svg";
export { ForwardRef as ReactComponent };